<template>
  <div class="evaluate-container">
    <h3 class="title">满意度评价</h3>

    <!-- 表情满意度 -->
    <div class="emoji-group">
      <div
        v-for="item in emojiList"
        :key="item.value"
        class="emoji-item"
        :class="{ active: emoji === item.value }"
        @click="emoji = item.value"
      >
        <span class="emoji">{{ item.icon }}</span>
        <div>{{ item.label }}</div>
      </div>
    </div>

    <!-- ⭐ 服务速度 -->
    <div class="item">
      <span>服务速度：</span>
      <el-rate v-model="rate_attitude"></el-rate>
    </div>

    <!-- ⭐ 解决方案 -->
    <div class="item">
      <span>解决方案：</span>
      <el-rate v-model="rate_solution"></el-rate>
    </div>

    <!-- 是否解决 -->
    <div class="item">
      <span style="margin-right: 10px">您的问题是否解决？</span>
      <el-radio-group v-model.number="solved">
        <el-radio :label="1">已解决</el-radio>
        <el-radio :label="0">未解决</el-radio>
      </el-radio-group>
    </div>

    <div v-if="solved === 0" class="item">
      <span>未解决原因：(多选)</span>
      <el-checkbox-group v-model="reasonList" class="checkbox-list">
        <el-checkbox
          v-for="cause in rootCauseList"
          :key="cause.id"
          :label="cause.id"
        >
          {{ cause.rootCause }}
        </el-checkbox>
      </el-checkbox-group>
    </div>

    <div v-if="solved === 0 && reasonList.includes(0)" class="item">
      <span style="margin-right: 10px">原因说明：</span>
      <el-input
        type="textarea"
        style="width: 300px"
        v-model="otherReason"
        placeholder="请输入其他原因"
      ></el-input>
    </div>

    <!-- 最不满意的节点 -->
    <div class="item">
      <span style="margin-right: 10px">最不满意的节点：</span>
      <el-select
        v-model="selectedRecord"
        placeholder="请选择"
        style="width: 250px"
      >
        <el-option
          v-for="record in recordList"
          :key="record.id"
          :label="record.operateUser"
          :value="record.id"
        />
      </el-select>
    </div>

    <!-- 提交按钮 -->
    <div style="margin-top: 30px; text-align: center">
      <el-button type="primary" @click="submit">提交</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/api/process'

export default {
  name: 'CustomerEvaluate',
  props: {
    processId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      emoji: 3,
      rate_attitude: 3,
      rate_solution: 3,
      solved: 1,

      // 后端数据
      rootCauseList: [],
      recordList: [],

      // 未解决原因复选框
      reasonList: [],
      otherReason: '',

      // 下拉框选择
      selectedRecord: null,

      emojiList: [
        { value: 1, label: '非常不满意', icon: '😠' },
        { value: 2, label: '不满意', icon: '☹️' },
        { value: 3, label: '一般', icon: '😐' },
        { value: 4, label: '满意', icon: '🙂' },
        { value: 5, label: '非常满意', icon: '😍' },
      ],
    }
  },

  created() {
    this.fetchData()
  },
  watch: {
    solved(newVal) {
      if (newVal === 1) {
        // 如果切换成“已解决”，清空未解决相关字段
        this.reasonList = []
        this.otherReason = ''
      }
    },
  },

  methods: {
    async fetchData() {
      const res = await api.getEvaluateData(this.processId)
      this.rootCauseList = res.data.rootCauseList
      this.recordList = res.data.recordList
    },

    submit() {
      const payload = {
        score: this.emoji,
        speedEvaluation: this.rate_attitude,
        programEvaluation: this.rate_solution,
        isCompleted: this.solved,
        unresolvedCauseIds: this.reasonList,
        otherReason: this.otherReason,
        leastSatisfactoryStep: this.selectedRecord,
      }

      api
        .submitEvaluation({
          processId: this.processId,
          ...payload,
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('提交成功')
          } else {
            this.$message.error(res.message || '提交失败')
          }
        })
        .catch((err) => {
          console.error('提交出错：', err)
          this.$message.error('网络异常或服务器错误')
        })
    },
  },
}
</script>

<style scoped>
.evaluate-container {
  padding: 20px;
  background: #fff;
}

.title {
  margin-bottom: 10px;
  font-weight: bold;
}

.emoji-group {
  display: flex;
  justify-content: space-between;
}

.emoji-item {
  cursor: pointer;
  width: 60px;
  text-align: center;
}

.emoji-item.active {
  transform: scale(1.1);
  color: #f90;
}

.emoji {
  font-size: 32px;
}

.item {
  margin-top: 20px;
  display: flex;
  align-items: center;
}

.checkbox-list {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
}
</style>
